import React from "react";
import * as Icons from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

const icons = ["ChefHat", "Camera", "Vote", "Globe2", "Heart", "Users", "Salad", "MoonStar"];

export const Features = () => {
  const { t } = useLang();
  return (
    <section id="features" className="scroll-mt-24 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-widest text-terracotta">
              {t.features.badge}
            </p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-petrol sm:text-4xl">
              {t.features.title}
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-petrol-soft">
              {t.features.subtitle}
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.features.items.map((f, i) => {
            const Icon = Icons[icons[i]] || Icons.Sparkles;
            return (
              <Reveal key={f.title} delay={(i % 4) * 0.07}>
                <div
                  data-testid={`feature-card-${i}`}
                  className="group h-full rounded-3xl bg-cream p-7 transition-transform duration-200 hover:-translate-y-1.5"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-terracotta/12 text-terracotta transition-colors duration-200 group-hover:bg-terracotta group-hover:text-white">
                    <Icon className="h-6 w-6" strokeWidth={2} />
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-bold text-petrol">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-petrol-soft">
                    {f.text}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
